<template>
    <footer class="site-footer">
        <div class="site-footer__container">
            <div class="site-footer__copy">
                <span>&copy; {{ currentYear }} {{ companyName }}</span>
            </div>
            <ul class="site-footer__navigation">
                <li>
                    <a :href="impressumUrl" target="_blank">Impressum</a>
                </li>
                <li>
                    <a :href="datenschutzUrl" target="_blank">Datenschutz</a>
                </li>
                <li>
                    <RouterLink :to="{ name: 'AccessibilityStatement' }" class="site-footer__link">Barrierefreiheit</RouterLink>
                </li>
            </ul>
        </div>
    </footer>
</template>

<script>
import useDomainConfig from '@/composables/useDomainConfig';
export default {
    setup() {
        const { 
                impressumUrl, 
                datenschutzUrl,
                companyName
            } = useDomainConfig();
        return {
            impressumUrl,
            datenschutzUrl,
            companyName
        };
    },
    data() {
        return {
            currentYear: new Date().getFullYear(),
        };
    },
};
</script>

<style lang="scss" >
    .site-footer {
        
        &__container {
            @extend %site-grid;
        }

        &__copy {
            @extend %site-column;
            // margin:rem(15px 0);
            span {
                
                color:var(--color-white);
                display: block;
                font-size:rem(14px);
                font-weight: 400;
                line-height: rem(20px);
                padding:rem(15px 10px);
                text-align: center;
            }   
        }
        
        &__navigation {
            @extend %site-column;
            padding: rem(20px 0);
                li {
                    display: block;
                    padding:rem(5px 0px);
                    text-align: center;
                    a {
                        color:#fff;
                         font-size:rem(14px);
                        font-weight: 500;
                        line-height: rem(20px);
                        
                        text-decoration: none;
                        text-transform: uppercase;
                        transition: var(--default-transition);
                        will-change: color;
                        padding: 0;
                        margin: 0;
                        min-height: rem(22px)!important;
                    }
                }
           
            
        }
        @include desktop {
            padding: rem(50px 0 15px 0);
         
            &__copy {
                span{
                    color:var(--primary-color);
                    padding:rem(5px 10px);
                    text-align: left;
                }
            }
            &__navigation {
                display: block;
                list-style: none;
                margin:0;
                text-align: right;
                li {
                    display: inline-block;
                    padding:rem(5px 10px);

                    a{
                        color:var(--link-color);
                       

                        &::after {
                            background-color: var(--link-color-hover);
                            display: block;
                            content: '';
                            height: rem(1.5px);
                            width: 0;
                            will-change: width;
                            transition: var(--default-transition);
                        }
                        &:hover {
                            color:var(--link-color-hover);
                            &::after {
                                // width: 100%;
                            }
                        }
                    }
                }   
            }
        }
    }
</style>